const userOrder = {
  header: {
    toolbar: {
      all: 'Усі',
      keyword: 'Ключове слово',
      direct: 'Прямий',
      cpi: 'CPI',
      hqr: 'HQR',
    }

  },
  table: {
    adminUserCampaigns: 'Кампанії користувача-адміністратора',
    showing: 'показується',
    campaignsOf: 'кампанії з',
    found: 'знайдено',
    campaignFrom: 'кампанія з',
    nothingFoundBySearch: 'Нічого не знайдено за допомогою пошуку',
    noCampaignsFound: 'Кампаній не знайдено',
    submit: 'Надіслати',
    changeVendor: 'Змінити постачальника'
  },
  messages: {
    messageSent: 'Повідомлення успішно надіслано'
  },
  modal: {
    sendMessage: 'Надіслати повідомлення',
    recordsNotFound: 'Записи не знайдено',
    statusChangeHistory: 'зміна статусу history',
    changeProgress: 'Хід оновлення',
  },
  actionsDropdown: {
    updateProgress: 'Хід оновлення',
  }
};

export default userOrder;
